// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 594 ? "about" : chunkId) + "." + {"310":"49a9db67","586":"8f6547b0","594":"3b1d1308"}[chunkId] + ".css";
};